import { c as _c } from "react/compiler-runtime";
import * as SwitchPrimitives from "@radix-ui/react-switch";
import * as React from "react";
import cn from "twsx";

// Linear switch: track 22×14 (radius 72), thumb 10×10 inset 2px, accent track
// when on, 1px accent focus outline, opacity 0.5 when disabled.
/** Use when a setting turns on or off immediately. */
const Switch = t0 => {
  const $ = _c(11);
  let className;
  let props;
  let ref;
  if ($[0] !== t0) {
    ({
      className,
      ref,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = ref;
  } else {
    className = $[1];
    props = $[2];
    ref = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("peer inline-flex h-3.5 w-5.5 shrink-0 cursor-pointer items-center rounded-full p-0.5 outline-none", "focus-visible:outline focus-visible:outline-1 focus-visible:outline-offset-2 focus-visible:outline-accent", "disabled:cursor-not-allowed disabled:opacity-50", "data-[state=checked]:bg-control-checked data-[state=unchecked]:bg-switch-off", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SwitchPrimitives.Thumb className={cn("pointer-events-none block size-2.5 rounded-full bg-text-on-accent", "data-[state=checked]:translate-x-2 data-[state=unchecked]:translate-x-0")} />;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== props || $[8] !== ref || $[9] !== t1) {
    t3 = <SwitchPrimitives.Root className={t1} {...props} ref={ref}>{t2}</SwitchPrimitives.Root>;
    $[7] = props;
    $[8] = ref;
    $[9] = t1;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};
Switch.displayName = SwitchPrimitives.Root.displayName;
export { Switch };